import { render, staticRenderFns } from "./ExportXlsxButton.vue?vue&type=template&id=bfe0870e&scoped=true&"
import script from "./ExportXlsxButton.vue?vue&type=script&lang=js&"
export * from "./ExportXlsxButton.vue?vue&type=script&lang=js&"
import style0 from "./ExportXlsxButton.vue?vue&type=style&index=0&id=bfe0870e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe0870e",
  null
  
)

export default component.exports